export const subscribe = async (supabase, email) => {
  try {
    const result = await supabase
      .from('newsletter_emails')
      .insert([{ email }]);
    
    if (result.error) {
      // Check if it's a duplicate email error
      if (result.error.code === '23505') {
        return { success: false, error: 'This email is already subscribed!' };
      }
      return { success: false, error: 'Failed to subscribe. Please try again.' };
    }
    
    return { success: true };
  } catch (error) {
    console.error('subscribe newsletter method:', error);
    return { success: false, error: 'An unexpected error occurred.' };
  }
};

export const getAll = async (supabase) => {
  try {
    const result = await supabase
      .from('newsletter_emails')
      .select('*')
      .order('subscribed_at', { ascending: false });
    
    if (result.error) {
      console.error('getAll newsletter method:', result.error);
      return [];
    }
    
    return result.data || [];
  } catch (error) {
    console.error('getAll newsletter method:', error);
    return [];
  }
};

export const deleteByEmail = async (supabase, email) => {
  try {
    const result = await supabase
      .from('newsletter_emails')
      .delete()
      .eq('email', email);
    
    if (result.error) {
      console.error('deleteByEmail newsletter method:', result.error);
      return { success: false };
    }
    
    return { success: true };
  } catch (error) {
    console.error('deleteByEmail newsletter method:', error);
    return { success: false };
  }
};

